import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("circle", {
  cx: "12",
  cy: "12",
  r: "1"
}), ___EmotionJSX("circle", {
  cx: "19",
  cy: "12",
  r: "1"
}), ___EmotionJSX("circle", {
  cx: "5",
  cy: "12",
  r: "1"
}));
export default SVG;